export const serverUrl = process.env.API_URL || 'https://api.estackk.com';
// export const serverUrl = process.env.API_URL || 'http://localhost:8000';
// export const serverUrl = process.env.API_URL || 'http://134.249.227.172:8000';
export const apiUrl = `${serverUrl}`;
